// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-admin-layout',
    props: {
        widthMode: {
            type: String,
            required: false,
            default: 'default'
        },
    },
});
// #endregion
